export enum TrainingType {
  AVOT = 'AVOT',
  ORT = 'ORT',
  ADT = 'ADT',
  TTM = 'TTM',
  EHVS = 'EHVS',
}
